const getCurrentTableField = (fieldName, tableFields) => {
	const fieldData = tableFields?.find((x) => x.name == fieldName)
	return fieldData ? fieldData : null
}

export default getCurrentTableField
